import FacilityManagementService from "./FacilityManagementService";

export default class FacilityService {
  static async getAllFacilities(params = {}) {
    try {
      const axiosResponse = await FacilityManagementService.getFacilityList({
        pageNumber: params.pageNumber || 1,
        limit: params.limit || 100, // Get more facilities for dropdown
        name: params.name || "",
        status: params.status || "Active", // Only get active facilities
      });

      // Extract the actual data from axios response
      const response = axiosResponse.data;

      if (response.success && response.facilitys) {
        const mappedFacilities = response.facilitys.map((facility) => ({
          label: facility.name,
          value: facility.id,
          ...facility, // Include all facility data for future use
        }));

        return {
          success: true,
          facilities: mappedFacilities,
        };
      }

      return {
        success: false,
        facilities: [],
        error: response.message || "Failed to fetch facilities",
      };
    } catch (error) {
      console.error("Error fetching facilities:", error);
      return {
        success: false,
        facilities: [],
        error: error.message || "Failed to fetch facilities",
      };
    }
  }
}
